import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE } from "@/data/site";
import { useLang } from "@/lib/i18n";

// Final-page "Ready when you are" CTA. Replaces the old "Need a plumber right now"
// block and provides a smoother transition into the footer via a dark gradient
// that matches the footer's brand-navy-dark.
export default function ReadyCTA() {
  const { t } = useLang();

  return (
    <section
      data-testid="ready-cta"
      className="relative section-padding bg-gradient-to-b from-brand-navy via-brand-navy-dark to-brand-navy-dark text-white overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-brand-yellow/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-[360px] h-[360px] rounded-full bg-brand-navy-light/15 blur-3xl pointer-events-none" />

      <div className="container-max relative grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-yellow">
            {t.common.ready}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold mt-2 leading-tight">
            {t.common.readyTitle}
          </h2>
          <p className="mt-4 text-white/75 text-lg max-w-2xl">
            {t.common.readySub}
          </p>
        </div>
        <div className="grid gap-3">
          <a
            data-testid="ready-call-cta"
            href={`tel:${SITE.primaryPhone}`}
            className="inline-flex items-center justify-center gap-2 bg-brand-yellow hover:bg-brand-yellow-dark text-slate-900 font-bold py-4 px-6 rounded-xl whitespace-nowrap shadow-lg shadow-yellow-300/20"
          >
            <Phone size={18} />
            <span>{t.cta.call} {SITE.primaryPhone}</span>
          </a>
          <Link
            data-testid="ready-quote-cta"
            to="/contact"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-brand-yellow text-white hover:text-brand-yellow font-bold py-4 px-6 rounded-xl transition-colors whitespace-nowrap"
          >
            {t.cta.freeEstimate}
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold py-2 px-6 transition-colors"
          >
            {t.cta.browseAll} <ArrowRight size={14} />
          </Link>
        </div>
      </div>

      {/* Smooth color bridge into the dark footer */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent via-brand-navy-dark to-brand-navy-dark pointer-events-none"
      />
    </section>
  );
}
